var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetch } from '@mitchell/typescript.service.fetch';
import { EnvironmentService, handleResponseNoContent, HttpCacheType, HttpContentType, HttpHeaderType, HttpMethodType } from "../../common";
import { PhotoCaptureServiceHeader } from '../constants';
export class IntelligentPhotoCaptureErrorLogService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
    }
    errorLog(companyCode, requestPayload, instanceReferenceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `${EnvironmentService.getEnvironment().apdApiGatewayRoot}photo-based-estimating-orch-api/v1/companies/${companyCode}/error-log`;
            const request = new Request(uri, {
                method: HttpMethodType.POST,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.ACCEPT]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.PRAGMA]: HttpCacheType.NO_CACHE,
                    [HttpHeaderType.XMI_CALLER]: PhotoCaptureServiceHeader.applicationName,
                    [HttpHeaderType.XMI_REQUEST_ID]: instanceReferenceId
                }),
                body: JSON.stringify(requestPayload)
            });
            const response = yield this.fetchWrapper(request);
            yield handleResponseNoContent(response);
        });
    }
}
//# sourceMappingURL=IntelligentPhotoCaptureErrorLogService.js.map